import { memo, type ReactNode } from 'react';

import { SearchIcon } from '@air/design-icons';

import { NullState } from '~/components/NullState';
import { NullStateLink } from '~/components/NullStateLink';

export type NoSearchResultsProps = {
  location: string | undefined;
  /** Primary action, e.g. widening the search to all assets. */
  action?: ReactNode;
  /** Hides the Air help-center link, for branded pages shown to external viewers. */
  hideHelpLink?: boolean;
};

export const NoSearchResults = memo(({ action, hideHelpLink = false, location }: NoSearchResultsProps) => (
  <NullState
    icon={SearchIcon}
    title={location ? `No results found in ${location}` : 'No results found'}
    description={<span data-testid="NO_SEARCH_RESULTS">Try a different search term or check your filters.</span>}
  >
    {action}
    {!hideHelpLink && (
      <NullStateLink href="https://help.air.inc/en/articles/3397283-searching-for-your-content">
        Learn how search works
      </NullStateLink>
    )}
  </NullState>
));

NoSearchResults.displayName = 'NoSearchResults';
